
import { Component, Vue } from 'vue-property-decorator';
import { eventService } from "../../shared/services/EventService";

@Component
export default class UpdateBarometerButton extends Vue {

    public track() {
        eventService.track('Navigation', 'Click Update Barometer Button');
    }

}
